export default __webpack_public_path__ + "static/media/020-u turn.cc1171e5.png";